import { render, staticRenderFns } from "./SocialHistoryDetails.vue?vue&type=template&id=3bfcb9a0&"
import script from "./SocialHistoryDetails.vue?vue&type=script&lang=js&"
export * from "./SocialHistoryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports